import { render } from "./FilterAttendance.vue?vue&type=template&id=6edd77b4&scoped=true&ts=true"
import script from "./FilterAttendance.vue?vue&type=script&lang=ts"
export * from "./FilterAttendance.vue?vue&type=script&lang=ts"

import "./FilterAttendance.vue?vue&type=style&index=0&id=6edd77b4&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edd77b4"]])

export default __exports__